import type { AppRedirect } from 'src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/causes/:slug',
		buildUrl: () => '/',
	},
];
